import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const SnowMaps = ({ surfaces }) => {
  const mapRef = useRef(null);
  const [mapInstance, setMapInstance] = useState(null);

  const initializeMap = () => {
    if (!mapRef.current) return null;

    const map = L.map(mapRef.current, {
      center: [17.4065, 78.4772],
      zoom: 14
    });

     L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    maxZoom: 20
  }).addTo(map);

    return map;
  };

  useEffect(() => {
    const map = initializeMap();
    if (!map) return undefined;

    setMapInstance(map);

    return () => {
      map.remove();
    };
  }, []);

    const renderSurfaces = (map) => {
        if (!map || !surfaces || surfaces.length === 0) return;

        map.eachLayer((layer) => {
            if (layer instanceof L.Polygon) {
            map.removeLayer(layer);
            }
        });

        const allBounds = [];

        const snowSurfaces = surfaces.filter(
            surface => surface.snow_management === true
        );


        snowSurfaces.forEach((surface) => {
            const coords = surface.geometry?.coordinates;
            if (!coords) return;

            let polygonCoords = [];

            if (Array.isArray(coords[0][0][0])) {
            // eslint-disable-next-line prefer-destructuring
            polygonCoords = coords[0][0];
            } else if (Array.isArray(coords[0][0])) {
            // eslint-disable-next-line prefer-destructuring
            polygonCoords = coords[0];
            } else if (Array.isArray(coords[0])) {
            polygonCoords = coords;
            } else {
            return;
            }

            const latLngs = polygonCoords
            .filter(c => Array.isArray(c) && c.length >= 2)
            .map(([lng, lat]) => [lat, lng]);

            if (latLngs.length === 0) return;

            allBounds.push(...latLngs);

            const polygonStyle = {
            color: '#d60000',
            weight: 2.5,
            fillColor: '#ff8080',
            fillOpacity: 0.5
            };

            const polygon = L.polygon(latLngs, polygonStyle).addTo(map);

            polygon.bindPopup(
            `${surface.name || 'Surface'}<br />Type: ${
                surface.surface_type?.name || 'Unknown'
            }`
            );
        });

        if (allBounds.length > 0) {
            map.fitBounds(allBounds);
        }
    };


  useEffect(() => {
    if (!mapInstance) return;
    renderSurfaces(mapInstance);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapInstance, surfaces]);

  return (
    <div style={{ height: '500px', width: '100%' }}>
      <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};

export default SnowMaps;
